import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Setup the application and structure
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Import the main module (not lazy loaded)
import { MainModule } from '@carm/base-layout/main/main.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SiteConfigModule } from '@carm/_configs/site-config.module';
import { MetadataEffects } from '@carm/_configs/store/effects/metadata.effects';
import { RoleTypePermissionEffects } from '@carm/_configs/store/effects/role-type-permissions.effects';
import { metadataKey, metadataReducer } from '@carm/_configs/store/reducers/metadata.reducer';
import { carmPermissionsKey, roleTypePermissionReducer } from '@carm/_configs/store/reducers/role-type-permission.reducer';
import { notificationFeatureKey, notificationReducer } from '@carm/_core/notification-mgt/store/notification.reducer';
import { BasePageComponent } from '@carm/_utils/base-page.component';
import { AngularMaterialModule } from '@carm/shared/material-modules/angular-material.module';
import { SharedModule } from '@carm/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { provideTranslateService, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { CoreModule } from './_core/core.module';
import { SessionTimeoutModule } from './shared/components/session-timeout/session-timeout.module';
import { NotFoundComponent } from './features/private/not-found/not-found.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DashboardModule } from './features/private/dashboard/dashboard.module';
import { DashboardSharedModule } from './features/private/dashboard-shared/dashboard-shared.module';
import { DeploymentTimeoutModule } from './shared/components/deployment-timeout/deployment-timeout.module';
import { carmProgramsListKey, programListReducer } from './_configs/store/reducers/program-list.reducer';
import { ProgramListEffects } from './_configs/store/effects/program-list.effects';
import { provideNgxMask } from 'ngx-mask';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { CustomsBrokersListComponent } from './features/public/customs-brokers/components/customs-brokers-list.component';

@NgModule({
  declarations: [
    AppComponent,
    BasePageComponent,
    NotFoundComponent,
    CustomsBrokersListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    DashboardModule,
    DashboardSharedModule,
    DeploymentTimeoutModule,
    MainModule,
    SiteConfigModule,
    SessionTimeoutModule,
    EffectsModule.forFeature([MetadataEffects, RoleTypePermissionEffects, ProgramListEffects]),
    StoreModule.forFeature(metadataKey, metadataReducer),
    StoreModule.forFeature(notificationFeatureKey, notificationReducer),
    StoreModule.forFeature(carmPermissionsKey, roleTypePermissionReducer),
    StoreModule.forFeature(carmProgramsListKey, programListReducer),
    BrowserAnimationsModule,
    AngularMaterialModule,
    TranslateModule.forRoot({
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
    }),
  ],
  providers: [
    {
    provide: 'externalUrlRedirectResolver',
    useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        window.location.href = (route.data as any).externalUrl;
      },
    },
    CookieService,
    provideNgxMask(),
    provideAnimationsAsync('animations'),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
        enforceLoading: true // Adds cache-busting timestamp
      }),
      fallbackLang: 'en',
      lang: 'en'
    })
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
